"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactStripeJs = require("@stripe/react-stripe-js");

var _stripeJs = require("@stripe/stripe-js");

var _config = require("../config");

var _PaymentForm = _interopRequireDefault(require("./PaymentForm"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("formPage", _flowRuntime["default"].object()), _flowRuntime["default"].property("submitBtnText", _flowRuntime["default"].string()), _flowRuntime["default"].property("onSuccess", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())))));

var _default = function _default(_arg) {
  var formPage = _arg.formPage,
      onSuccess = _arg.onSuccess,
      submitBtnText = _arg.submitBtnText;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      stripePromise = _useState2[0],
      setStripePromise = _useState2[1];

  (0, _react.useEffect)(function () {
    setStripePromise((0, _stripeJs.loadStripe)((0, _config.getStripePublishableKey)()));
  }, []);
  return stripePromise ? /*#__PURE__*/_react["default"].createElement(_reactStripeJs.Elements, {
    stripe: stripePromise
  }, /*#__PURE__*/_react["default"].createElement(_PaymentForm["default"], {
    formPage: formPage,
    key: formPage.key,
    onSuccess: onSuccess,
    submitBtnText: submitBtnText
  })) : null;
};

exports["default"] = _default;